module.exports = __webpack_public_path__ + "img/DOWN.c6b4691b.svg";